// import { service } from '@/plugin/axios'
import { service } from './service';
var request = {
  post: function post(url, data) {
    return service.post(url, data);
  },
  put: function put(url, data) {
    return service.put(url, data);
  },
  get: function get(url, query) {
    if (!query) {
      return service.get(url);
    }

    return service.get(url, {
      params: query
    });
  },
  delete: function _delete(url, data) {
    if (!data) {
      return service.delete(url);
    }

    return service.delete(url, {
      params: data
    });
  }
};
export default request;